import { Navigate, type RouteObject } from "react-router-dom";
import { PermissionedRoutes } from "@components/PermissionedRoutes";
import { PERMISSIONS, FEATURE_FLAGS, BASE_PATH } from "./constants";

export const PRODUCT_LIST_MANAGER_V2_ROUTES: RouteObject[] = [
  {
    element: (
      <PermissionedRoutes
        requiredRoles={["narmi"]}
        requiredFeatures={[FEATURE_FLAGS.PRODUCT_LIST_MANAGER_V2]}
        requiredPermissions={[PERMISSIONS.VIEW_PRODUCTS]}
      />
    ),
    children: [
      {
        index: true,
        element: <Navigate to={`${BASE_PATH}/consumer`} replace />,
      },
      {
        path: ":type",
        lazy: async () => {
          const { default: ProductListPage } = await import("./pages/product_list/ProductListPage");
          return { Component: ProductListPage };
        },
      },
      {
        path: ":type/:uuid",
        lazy: async () => {
          const { default: ProductListPage } = await import("./pages/product_list/ProductListPage");
          return { Component: ProductListPage };
        },
      },
    ],
  },
];
